"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/OnboardingDemo/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');
var _hooks = require('web/services/hooks');
var _reactcalendly = require('react-calendly');

var _supportUrls = require('shared/data/supportUrls');
var _signup = require('shared/enum/signup');
var _user = require('shared/selectors/user');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Form = require('web/components/Form');
var _components = require('web/screens/Signup/components');





var _onboardingShared = require('web/screens/onboardingShared');







var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _ui = require('web/services/ui');

 const EMBED_FAILURE_TIMEOUT_MS = 12000; exports.EMBED_FAILURE_TIMEOUT_MS = EMBED_FAILURE_TIMEOUT_MS

// Default matches the slimmed (details-hidden) Calendly page height; grown by the live
// `calendly.page_height` postMessage so the calendar never scrolls inside
// the iframe. The default is also the floor: Calendly emits small heights
// while its page is still skeleton-loading, and honoring those would
// truncate the calendar. The cap keeps a malformed message from exploding
// the layout.
 const EMBED_DEFAULT_HEIGHT = 560; exports.EMBED_DEFAULT_HEIGHT = EMBED_DEFAULT_HEIGHT
 const EMBED_MAX_HEIGHT = 1400; exports.EMBED_MAX_HEIGHT = EMBED_MAX_HEIGHT



// The bloomtext-demo Calendly event's custom questions, by 1-based position:
// a1 "Your Organization" · a2 "How did you find out about us?" ·
// a3 "What features are you interested in?" · a4 free text (not prefilled).
// Calendly prefill is positional, so every answer is verified against the
// event's LIVE question list (GetDemoSchedulingStatus) before being sent —
// a renamed/reordered question is left blank rather than misfiled.
const CALENDLY_FEATURE_BY_INTEREST = {
  [_signup.ProductInterest.SMS]: 'Patient Engagement',
  [_signup.ProductInterest.TEAM_CHAT]: 'Team Communication',
  // EXTERNAL_CHAT has no matching answer choice; leave it to the invitee.
}

const EXPECTED_QUESTIONS = {
  a1: { position: 0, name: 'Your Organization' },
  a2: { position: 1, name: 'How did you find out about us?' },
  a3: { position: 2, name: 'What features are you interested in?' },
}








/**
 * Live check of the Calendly demo event via the backend passthrough: 'gone'
 * skips the step entirely; 'available' carries the current question list so
 * prefill only fills questions that still match; any failure is 'unknown'
 * (embed renders, identity-only prefill).
 */
const useDemoSchedulingStatus = (orgKey, enabled) => {
  const [status, setStatus] = _react.useState({ state: 'checking' })
  _react.useEffect.call(void 0, () => {
    if (!enabled || !orgKey) return
    let cancelled = false
    const degraded = (kind, err) => {
      // Once per org+kind: the degradation is per-visit identical, and the
      // backend separately Sentry-reports each actual Calendly lookup.
      emitOnce(`onb_demo_${orgKey}_err_${kind}`, () => {
        log.error(err)
        _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, { error_kind: kind, organization_id: orgKey })
      })
    }
    _actions2.default.getDemoSchedulingStatus({ OrgKey: orgKey  })
      .then(r => {
        if (cancelled) return
        if (_optionalChain([r, 'optionalAccess', _ => _.Status]) === 'gone') {
          degraded('demo_scheduling_gone', new Error('calendly demo event gone — demo step skipping itself'))
          setStatus({ state: 'gone' })
        } else if (_optionalChain([r, 'optionalAccess', _2 => _2.Status]) === 'available') {
          setStatus({ state: 'available', fields: r.CustomFields || [] })
        } else {
          degraded('demo_scheduling_lookup', new Error('calendly demo-event status unknown — prefill degraded'))
          setStatus({ state: 'unknown' })
        }
      })
      .catch(err => {
        if (cancelled) return
        degraded('demo_scheduling_lookup', err instanceof Error ? err : new Error(String(err)))
        setStatus({ state: 'unknown' })
      })
    return () => { cancelled = true }
  }, [enabled, orgKey])
  return status
}

/** True when the event's live question at the expected position still carries the expected name. */
const questionMatches = (fields, key) => {
  const expected = EXPECTED_QUESTIONS[key]
  return fields.some(f => f.Position === expected.position && f.Name === expected.name)
}

/** The event's live answer choices for the features question (empty when absent). */
const featureChoices = (fields) => {
  const expected = EXPECTED_QUESTIONS.a3
  const field = fields.find(f => f.Position === expected.position && f.Name === expected.name)
  return _optionalChain([field, 'optionalAccess', _3 => _3.AnswerChoices]) || []
}

const emitOnce = (key, emit) => {
  try {
    if (sessionStorage.getItem(key)) return
    sessionStorage.setItem(key, '1')
  } catch (e2) {
    // best-effort; storage may be unavailable in private modes
  }
  emit()
}

const OnboardingDemo = () => {
  const { orgParam, currentUser, isValidOrg } = _onboardingShared.useOnboardingOrgGate.call(void 0, )
  const org = _hooks.useAppSelector.call(void 0, s => (s.orgs || {})[orgParam])
  // Same authoritative read the payment screen uses; the answers prefill
  // Calendly's custom questions, so the widget waits for it to settle (a
  // failed read just renders without prefill — never blocks the step).
  const survey = _onboardingShared.useOnboardingSurvey.call(void 0, orgParam, isValidOrg)
  const surveySettled = survey.loaded || survey.failed
  const scheduling = useDemoSchedulingStatus(orgParam, isValidOrg)
  const schedulingGone = scheduling.state === 'gone'
  const schedulingSettled = scheduling.state !== 'checking'
  const isMobile = _ui.useScreenType.call(void 0, ) === 'mobile'
  const [embedState, setEmbedState] = _react.useState('pending')
  const [embedHeight, setEmbedHeight] = _react.useState.call(void 0, exports.EMBED_DEFAULT_HEIGHT)
  const [booked, setBooked] = _react.useState.call(void 0, false)
  // Once a slot is picked, Calendly's own form stage shows the full event
  // header (photo, name, time) — our compact host row would duplicate it,
  // so it collapses at that point.
  const [slotSelected, setSlotSelected] = _react.useState.call(void 0, false)
  const guardKey = (kind) => `onb_demo_${orgParam}_${kind}`

  const markEmbedLive = _react.useCallback.call(void 0, () => setEmbedState('live'), [])
  // PageHeightResizeEvent isn't exported from react-calendly's index; type
  // the payload structurally.
  const onPageHeightResize = _react.useCallback.call(void 0, 
    (e) => {
      setEmbedState('live')
      const height = parseInt(_nullishCoalesce(_optionalChain([e, 'optionalAccess', _4 => _4.data, 'optionalAccess', _5 => _5.payload, 'optionalAccess', _6 => _6.height]), () => ( '')), 10)
      if (Number.isFinite(height)) {
        setEmbedHeight(Math.min(Math.max(height, exports.EMBED_DEFAULT_HEIGHT), exports.EMBED_MAX_HEIGHT))
      }
    },
    [],
  )
  const onEventScheduled = _react.useCallback.call(void 0, () => {
    setEmbedState('live')
    setBooked(true)
    if (!orgParam) return
    emitOnce(guardKey('booked'), () =>
      _onboardingAnalytics.captureOnboardingDemoBooked.call(void 0, {
        organization_id: orgParam,
        source: 'demo_step',
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam])

  _reactcalendly.useCalendlyEventListener.call(void 0, {
    onPageHeightResize,
    onProfilePageViewed: markEmbedLive,
    onEventTypeViewed: markEmbedLive,
    onDateAndTimeSelected: () => {
      markEmbedLive()
      setSlotSelected(true)
    },
    onEventScheduled,
  })

  _react.useEffect.call(void 0, () => {
    if (isMobile || !surveySettled || !schedulingSettled || embedState !== 'pending') return
    const timer = window.setTimeout(() => {
      setEmbedState('failed')
      emitOnce(guardKey('err_demo_embed_load'), () => {
        log.error(new Error('calendly inline embed emitted no postMessage — demo step degraded to link-out'))
        _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, { error_kind: 'demo_embed_load', organization_id: orgParam })
      })
    }, exports.EMBED_FAILURE_TIMEOUT_MS)
    return () => window.clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, surveySettled, schedulingSettled, embedState, orgParam])

  // The Calendly event no longer exists: the step has nothing to offer, so
  // route straight to the confirmation instead of an empty interstitial.
  _react.useEffect.call(void 0, () => {
    if (schedulingGone && orgParam) _actions2.default.gotoOnboardingSteps(orgParam)
  }, [schedulingGone, orgParam])

  _react.useEffect.call(void 0, () => {
    if (!isValidOrg || !orgParam || !currentUser || !schedulingSettled || schedulingGone) return
    emitOnce(guardKey('viewed'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_VIEWED, {
        ..._onboardingAnalytics.DEMO_STEP_META,
        organization_id: orgParam,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidOrg, orgParam, currentUser, schedulingSettled, schedulingGone])

  const onContinue = _react.useCallback.call(void 0, () => {
    emitOnce(guardKey('completed'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED, {
        ..._onboardingAnalytics.DEMO_STEP_META,
        organization_id: orgParam,
      }))
    _actions2.default.gotoOnboardingSteps(orgParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam])

  const onScheduleClick = _react.useCallback.call(void 0, () => {
    _onboardingAnalytics.captureOnboardingDemoClicked.call(void 0, {
      organization_id: orgParam,
      source: 'demo_step',
    })
  }, [orgParam])

  if (!currentUser || !isValidOrg) {
    return _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}, _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 235}} ))
  }

  const name = [currentUser.FirstName, currentUser.LastName].filter(Boolean).join(' ')
  const showFallback = isMobile || embedState === 'failed'
  // Prefill only what the event's live question list confirms: identity
  // (name/email) is never positional, but a1–a3 are — an unverified or
  // changed question stays blank rather than receiving the wrong answer.
  const liveFields = scheduling.state === 'available' ? scheduling.fields : []
  const features = [..._onboardingShared.parseProductInterest.call(void 0, survey.productInterest)]
    .map(interest => CALENDLY_FEATURE_BY_INTEREST[interest])
    .filter((f) => !!f && featureChoices(liveFields).includes(f))
    .join(',')
  const customAnswers = scheduling.state === 'available'
    ? {
        ...(_optionalChain([org, 'optionalAccess', _7 => _7.Name]) && questionMatches(liveFields, 'a1') ? { a1: org.Name } : {}),
        ...(survey.referrer && questionMatches(liveFields, 'a2') ? { a2: survey.referrer } : {}),
        ...(features ? { a3: features } : {}),
      }
    : {}
  const linkOutParams = new URLSearchParams({
    name,
    email: currentUser.Email,
    ...customAnswers,
  }).toString()
  const linkOutUrl = `${_supportUrls.scheduleDemoUrl}?${linkOutParams}`

  return (
    _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 263}}
      , _react2.default.createElement('section', { className: "onboarding-demo", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
        , _react2.default.createElement('h1', { className: "onboarding-demo--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}, "Want a hand getting started with BloomText?"      )
        , _react2.default.createElement('p', { className: "onboarding-demo--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
          ,  booked
            ? "You're booked! We'll see you soon."
            : 'Pick a time with our team, or continue whenever you are ready.' 
        )

         /* Compact host row — replaces the Calendly profile header the slim
             embed hides (hideEventTypeDetails), at a fraction of its height.
             Hidden once a slot is picked: Calendly's form stage shows the
             full event header itself. */ 
        ,  !slotSelected && _react2.default.createElement('div', { className: "onboarding-demo--host", __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
          , _react2.default.createElement('img', {
            className: "onboarding-demo--host-avatar",
            src: "/assets/images/welcome/demo-host.png",
            alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
          )
          , _react2.default.createElement('div', { className: "onboarding-demo--host-info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
            , _react2.default.createElement('p', { className: "onboarding-demo--host-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 283}}, "Tyler Brown" )
            , _react2.default.createElement('p', { className: "onboarding-demo--host-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}}, "BloomText demo · 30 min · video call"       )
          )
        ) 

         /* The scheduling-status gate comes FIRST: until the event is
             confirmed to exist, neither the embed nor the mobile link-out
             may render — a gone event would otherwise expose a dead link
             during the lookup window. */ 
        ,  !schedulingSettled || schedulingGone || (!isMobile && !surveySettled)
          ? (
            _react2.default.createElement('div', { className: "onboarding-demo--embed onboarding-demo--embed-loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 294}}
              , _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 295}} )
            )
            )
          : showFallback
            ? (
              _react2.default.createElement('div', { className: "onboarding-demo--fallback", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}
                , _react2.default.createElement('p', { className: "onboarding-demo--fallback-copy", __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}}, "Open our scheduling page to choose a time that works for you."

                )
                , _react2.default.createElement('a', {
                  className: "blm-btn blm-btn--primary onboarding-demo--schedule-link"  ,
                  href: linkOutUrl,
                  target: "_blank",
                  rel: "noopener noreferrer" ,
                  onClick: onScheduleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}}
, "Schedule a demo"

                )
              )
              )
            : (
            _react2.default.createElement('div', { className: "onboarding-demo--embed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 316}}
              , _react2.default.createElement(_reactcalendly.InlineWidget, {
                url: _supportUrls.scheduleDemoUrl,
                prefill: { name, email: currentUser.Email, customAnswers },
                // Slim embed: the screen's own title carries the context, so
                // Calendly's profile/description header is duplicate chrome.
                pageSettings: {
                  hideEventTypeDetails: true,
                  hideLandingPageDetails: true,
                  hideGdprBanner: true,
                },
                styles: { minWidth: '320px', height: `${embedHeight}px` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 317}}
              )
            )
              ) 

        , _react2.default.createElement('div', { className: "onboarding-demo--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 332}}
          , _react2.default.createElement(_Form.Button, { onClick: onContinue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 333}}, "Continue")
        )
      )
    )
  )
}

const OnboardingDemoByOrg = () => {
  const { search } = _reactrouterdom.useLocation.call(void 0, )
  const orgKey = new URLSearchParams(search).get('org') || ''
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)
  return _react2.default.createElement(OnboardingDemo, { key: `${orgKey}:${_optionalChain([currentUser, 'optionalAccess', _8 => _8.UserKey]) || ''}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 344}} )
}

exports. default = OnboardingDemoByOrg
